import { render, staticRenderFns } from "./OrderDetailsItem.vue?vue&type=template&id=645df8c8&scoped=true&lang=pug&"
import script from "./OrderDetailsItem.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailsItem.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailsItem.vue?vue&type=style&index=0&id=645df8c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645df8c8",
  null
  
)

export default component.exports